import { render } from "./HomeIcon.vue?vue&type=template&id=4ff8cf75"
const script = {}
script.render = render

export default script